import { useState, useEffect } from 'react';
/**
 * ページとフォントのロード状態を返す
 */
export const usePageLoadStatus = () => {
    // フォントのロード状態
    const [fontsLoaded, setFontsLoaded] = useState(false);
    // ページ全体のロード状態
    const [pageLoaded, setPageLoaded] = useState(false);
    // フォントのロード状態を監視
    useEffect(() => {
        if (fontsLoaded || !document.fonts)
            return;
        // すでに読み込み済みの場合 true をセット
        if (document.fonts.status === 'loaded') {
            setFontsLoaded(true);
            return;
        }
        document.fonts.ready.then(() => setFontsLoaded(true));
    }, [fontsLoaded]);
    // ページ全体のロード状態を監視
    useEffect(() => {
        if (pageLoaded)
            return () => { };
        // すでに読み込み済みの場合 true をセット
        if (document.readyState === 'complete') {
            setPageLoaded(true);
        }
        const handleLoad = () => {
            setPageLoaded(true);
        };
        window.addEventListener('load', handleLoad);
        return () => {
            window.removeEventListener('load', handleLoad);
        };
    }, [pageLoaded]);
    return fontsLoaded && pageLoaded;
};
